import axios from "axios";
import toastHelper from "../components/utils/ToastHelper";

const api = axios.create({
  // baseURL: process.env.REACT_APP_API_SERVER || "http://localhost:3000/",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const isMutationMethod = (method) =>
  ["post", "put", "patch", "delete"].includes(method?.toLowerCase());

const toastExemptEndpoints = [
  "/api/users/login",
  "/api/users/logout",
  //
];

api.interceptors.response.use(
  (response) => {
    const method = response.config.method?.toLowerCase();
    const url = response.config.url || "";

    if (
      isMutationMethod(method) &&
      !toastExemptEndpoints.some((exempt) => url.includes(exempt))
    ) {
      const message =
        response.config.method === "delete"
          ? "Deleted successfully"
          : "Saved successfully";
      toastHelper.show(true, message);
    }
    return response;
  },
  (error) => {
    // Handle error globally

    let message = "Error: ";

    if (error.message) {
      message += error.message;
    }

    if (error.response?.data) {
      message += ": " + JSON.stringify(error.response.data);
    }

    toastHelper.show(false, message);
    return Promise.reject(error);
  }
);

export default api;
